<template>
  <div>
    <form @submit.prevent>
      <div class="pl-lg-4">
        <div class="row">
          <div class="col-lg-4">
            <base-input
              alternative=""
              required
              :label="$t('sku')"
              :placeholder="$t('sku')"
              input-classes="form-control-alternative border"
              v-model="model.sku"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('sku')"
              name="sku"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('sku')"
              ><small>{{ errors.first("sku") }}</small></span
            >
          </div>
          <div class="col-lg-4">
            <base-input
              alternative=""
              required
              :label="$t('name')"
              :placeholder="$t('name')"
              input-classes="form-control-alternative border"
              v-model="model.name"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('name')"
              name="name"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('name')"
              ><small>{{ errors.first("name") }}</small></span
            >
          </div>
          <div class="col-lg-4">
            <base-input :label="$t('category')" required>
              <v-select
                v-model="model.category"
                :placeholder="$t('selected-category')"
                class="form-control-alternative border bg-white p-1 rounded"
                :options="categoriesOptions"
                multiple
                data-vv-validate-on="blur"
                v-validate="'required'"
                :data-vv-as="$t('category')"
                name="category"
                autocomplete="off"
              >
                <template #no-options="{}">
                  {{ $t("fail") }},
                  <b-link class="text-danger" @click="$refs.create.showModal({data:null, company: $route.params.id})">{{
                    $t("create_category")
                  }}</b-link>
                </template></v-select
              >
              <span class="text-danger text-sm" v-show="errors.has('category')"
                ><small>{{ errors.first("category") }}</small></span
              >
            </base-input>
          </div>
          <div class="col-lg-12">
            <base-input
              alternative=""
              required
              :label="$t('description')"
              :placeholder="$t('description')"
              input-classes="form-control-alternative border"
              v-model="model.description"
              data-vv-validate-on="blur"
              v-validate="'required'"
              :data-vv-as="$t('description')"
              name="description"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('description')"
              ><small>{{ errors.first("description") }}</small></span
            >
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-lg-6">
            <base-input alternative="" :label="$t('coin')" required>
              <v-select
                :placeholder="$t('coin')"
               class="form-control-alternative border bg-white p-1 rounded"
                v-model="model.currency"
                data-vv-validate-on="blur"
                v-validate="'required'"
                :data-vv-as="$t('coin')"
                name="coin"
                :options="coinOptions"
                autocomplete="off"
              />
              <span class="text-danger text-sm" v-show="errors.has('coin')"
                ><small>{{ errors.first("coin") }}</small></span
              >
            </base-input>
          </div>
          <div class="col-lg-6">
            <base-input
              alternative=""
              required
              :label="$t('price')"
              :placeholder="$t('price')"
              input-classes="form-control-alternative border"
              v-model="model.price"
              data-vv-validate-on="blur"
              v-validate="'required|decimal:3'"
              :data-vv-as="$t('price')"
              type="number"
              name="price"
              autocomplete="off"
            />
            <span class="text-danger text-sm" v-show="errors.has('price')"
              ><small>{{ errors.first("price") }}</small></span
            >
          </div>
          <div class="col-md-12 mt-4 row justify-content-center">
          <div class="text-center col-md-4">
            <img
              style="max-height: 218px; max-width: 218px"
              :src="preview"
              alt="Users"
            />
           <b-button
              pill
              block
              size="sm"
              variant="primary mt-2"
              id="pick-image2"
              >{{ $t("picture") }}</b-button
            >
          </div>
            <avatar-cropper
              :upload-handler="selectedFile"
              @changed="setFileName"
              trigger="#pick-image2"
              :labels="{
                submit: $t('accept'),
                cancel: $t('cancel'),
              }"
              :cropper-options="{
                aspectRatio: 1,
                autoCropArea: 1,
                viewMode: 1,
                movable: false,
                zoomable: false,
              }"
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end">
        <base-button type="secondary" class="my-4" @click="close">{{
          $t("close", false)
        }}</base-button>
        <base-button type="primary" class="my-4" @click="add">{{
          $t("save")
        }}</base-button>
      </div>
    </form>
     <modal-create ref="create" />
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import AvatarCropper from "vue-avatar-cropper";
import helpers from "@/services/helpers";
import ModalCreate from "@/views/BackOffice/Categories/modalCreate";
export default {
  name: "create-company",
  props: {
    data: { default: null },
  },
  components: {
    AvatarCropper,
    ModalCreate,
  },
  async mounted() {
    await this.getCompanies();
    await this.getCurrency();
    await this.getCategories(this.$route.params.id);
    if (this.data) {
      this.model = {
        id: this.data.id,
        sku: this.data.sku,
        name: this.data.name,
        price: this.data.price,
        currency: { label: this.data.currency.name, value: this.data.currency.id },
        description: this.data.description,
        picture: this.data.picture,
        company_id: this.data.company_id,
        category: this.data.categories.map((item) => ({
          value: item.id,
          label: item.name,
        })),
      };
      this.preview = this.image(this.data.picture)
    } else {
      this.model = {
        id: null,
        sku: "",
        name: "",
        price: "",
        currency: null,
        description: "",
        picture: "",
        company_id: this.$route.params.id,
        category: null,
      },
      this.preview = require("@/assets/img/brand/no-image.jpg")
    }
    this.coinOptions = this.currencies.map(({ id: value, name: label }) => ({
          value,
          label,
        }));
  },
  data() {
    return {
      modalActive: false,
      dataCategory: {},
      model: {
        id: null,
        sku: "",
        name: "",
        price: null,
        currency: null,
        description: "",
        picture: null,
        company_id: "",
        category: [],
      },
      fileSelected: null,
      coinOptions: [],
      image: "",
      fileRecords: [],
      uploadUrl: "https://example.com",
      preview: ''
    };
  },
  methods: {
    changePage() {},
    ...mapActions({
      createProduct: "product/createOrUpdate",
      getCompanies: "company/getSelects",
      getCategories: "category/getSelects",
      getCurrency: "config/getCurrency",
    }),
    openModal(change) {
      this.modalActive = change;
    },

    filesChange(files) {
      this.model.picture = files;
    },
    setFileName(file) {
      this.fileSelected = file;
      this.model.picture = file;
    },
    selectedFile(cropper) {
      const dataUrl = cropper
        .getCroppedCanvas()
        .toDataURL(this.fileSelected.type);
      const file = helpers.dataURLtoFile(dataUrl, this.fileSelected.name);
      this.preview = dataUrl;
      this.model.picture = file;
    },
    async add() {
      try {
        const validation = await this.$validator.validateAll();
        if (validation) {
          const {
            id,
            sku,
            name,
            price,
            currency,
            description,
            picture,
            company_id,
            category,
          } = this.model;
          const dataProduct = new FormData();
          dataProduct.append("sku", sku);
          dataProduct.append("name", name);
          dataProduct.append("price", price);
          dataProduct.append("currency_id", currency.value);
          dataProduct.append("description", description);
          dataProduct.append("picture", picture ? picture : "");
          dataProduct.append("company_id", company_id);
          if (this.model.id) {
            dataProduct.append("_method", "PUT");
          }
          category.forEach((e, index) => {
            dataProduct.append(`category[${index}]`, e.value);
          });
          const res = await this.createProduct({ id: id, data: dataProduct });
          this.$emit("close", true);
          this.$toast.success(res.message, {
            position: "top-right",
          });
          // this.$router.push(`/companies-show/${this.model.company_id}`);
        }
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.$emit("close");
    },
  },
  computed: {
    ...mapGetters({
      companies: "company/companySelects",
      categories: "category/categorySelects",
      currencies: "config/currency",
    }),
    categoriesOptions() {
      if (this.categories.length > 0) {
        return this.categories.map(({ id: value, name: label }) => ({
          value,
          label,
        }));
      }
      return [];
    },
  },
};
</script>
